export const certificationsInfo = [
    { 
        certificationName: 'Associate Cloud Engineer',
        issuedOn: 'December, 2020',
        issuingOrganization: 'Google Cloud',
        imageUrl: process.env.PUBLIC_URL+'/images/gcp-logo.png',        
        credentialUrl: 'https://www.credential.net/e516d118-4daf-4cc1-8205-c0fc4658294c'
    },
    { 
        certificationName: 'AWS Certified Developer–Associate',
        issuedOn: 'November, 2020',
        issuingOrganization: 'Amazon Web Services (AWS)',
        imageUrl: process.env.PUBLIC_URL+'/images/aws-logo.png', 
        credentialUrl: 'https://www.youracclaim.com/badges/d7e7cef4-b207-44a9-b32f-dbc560524788?source=linked_in_profile'
    },
    { 
        certificationName: 'Tools of Computing (PCI)',
        issuedOn: 'June, 2019',
        issuingOrganization: 'Persistent Computing Institute',
        imageUrl: process.env.PUBLIC_URL+'/images/persistent-logo.png',
        credentialUrl: 'https://drive.google.com/file/d/143-Hoh8rLue_RtYSsHWjAg16JSAqAmoH/view'
    },
    { 
        certificationName: 'The Web Developer Bootcamp',
        issuedOn: 'August, 2020',
        issuingOrganization: 'Udemy',
        imageUrl: process.env.PUBLIC_URL+'/images/udemy-logo.png', 
        credentialUrl: 'https://www.udemy.com/certificate/UC-633182fb-71d9-4264-9532-861e4dcc0497/'
    },
    { 
        certificationName: 'Python Programming Masterclass',
        issuedOn: 'August, 2020',
        issuingOrganization: 'Udemy',
        imageUrl: process.env.PUBLIC_URL+'/images/udemy-logo.png', 
        credentialUrl: 'https://www.udemy.com/certificate/UC-6e0674f5-0779-4a02-9368-d7d40f3683dd/'
    },
    { 
        certificationName: 'Neural Networks and Deep Learning',
        issuedOn: 'June, 2020',
        issuingOrganization: 'Coursera',
        imageUrl: process.env.PUBLIC_URL+'/images/coursera-logo.png', 
        credentialUrl: 'https://www.coursera.org/account/accomplishments/certificate/AHSU5QU45G4D'
    },
    { 
        certificationName: 'Convolutional Neural Networks',
        issuedOn: 'June, 2020',
        issuingOrganization: 'Coursera',
        imageUrl: process.env.PUBLIC_URL+'/images/coursera-logo.png', 
        credentialUrl: 'https://www.coursera.org/account/accomplishments/certificate/FFWTAN4SDJ65'
    },
    { 
        certificationName: 'AI For Everyone',
        issuedOn: 'May, 2020',
        issuingOrganization: 'Coursera',
        imageUrl: process.env.PUBLIC_URL+'/images/coursera-logo.png', 
        credentialUrl: 'https://www.coursera.org/account/accomplishments/certificate/SG6CZHF2DVRN'
    },
    { 
        certificationName: 'How Google does Machine Learning',
        issuedOn: 'June, 2020',
        issuingOrganization: 'Coursera',
        imageUrl: process.env.PUBLIC_URL+'/images/coursera-logo.png', 
        credentialUrl: 'https://www.coursera.org/account/accomplishments/certificate/XLUH3UCNUKC4'
    },
    { 
        certificationName: 'Initiating and Planning Projects',
        issuedOn: 'June, 2020',
        issuingOrganization: 'Coursera',
        imageUrl: process.env.PUBLIC_URL+'/images/coursera-logo.png', 
        credentialUrl: 'https://www.coursera.org/account/accomplishments/certificate/2NNULD4V4UJJ'
    },
    { 
        certificationName: 'Programming With Python',
        issuedOn: 'June, 2018',
        imageUrl: process.env.PUBLIC_URL+'/images/internshala-logo.png', 
        issuingOrganization: 'Internshala',
        credentialUrl: 'https://drive.google.com/file/d/19JUHaqsDKmKdNExL_aigR2jlcisO8foq/view'
    },
    { 
        certificationName: 'Web Development',
        issuedOn: 'June, 2018',
        imageUrl: process.env.PUBLIC_URL+'/images/internshala-logo.png', 
        issuingOrganization: 'Internshala',
        credentialUrl: 'https://drive.google.com/file/d/1kah9Ls2dO1rU3A3G6KxuAQTyKMqMF5K8/view'
    }
];